import { render, staticRenderFns } from "./UpgradeNowCard.vue?vue&type=template&id=d52e7092"
import script from "./UpgradeNowCard.vue?vue&type=script&lang=js"
export * from "./UpgradeNowCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports